/* eslint-disable no-console */
/* eslint-disable camelcase */
/* global wc_cart_fragments_params, Cookies */

import $ from 'jquery';

class CartFragments {
  constructor() {
    this.active = false;
    this.data = null;

    if (
      typeof wc_cart_fragments_params === 'undefined' ||
      typeof Cookies === 'undefined'
    ) {
      return;
    }

    this.setActive();

    $(document.body).on('wc_fragments_refreshed', () => {
      this.setActive();
    });
  }

  setActive() {
    this.hashKey = wc_cart_fragments_params.cart_hash_key;
    this.fragmentName = wc_cart_fragments_params.fragment_name;

    if (this.hashKey) {
      this.aiuKey = `aiu_${this.hashKey}`;
      this.aiuFragmentName = `aiu_${this.fragmentName}`;
      const token = window.sessionStorage.getItem(this.hashKey);
      const cookieToken = Cookies.get('woocommerce_cart_hash');

      this.active =
        token === cookieToken &&
        `aiu_${this.fragmentName}` === this.aiuFragmentName;
    }
  }

  get() {
    if (!this.active) {
      return '';
    }

    const data = window.sessionStorage.getItem(this.aiuFragmentName);

    return data ? JSON.parse(data) : '';
  }

  set(data) {
    window.sessionStorage.setItem(this.aiuFragmentName, JSON.stringify(data));
  }
}

export default CartFragments;



// WEBPACK FOOTER //
// ./src/scripts/modules/cart-fragments.js